var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "hasPermi",
              rawName: "v-hasPermi",
              value: ["merchant:product:rule:page:list"],
              expression: "['merchant:product:rule:page:list']",
            },
          ],
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: "20px 20px 2px" },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品名称：" } },
                [
                  _c("el-input", {
                    staticClass: "form_content_width",
                    attrs: { placeholder: "请输入商品名称", clearable: "" },
                    model: {
                      value: _vm.keyword,
                      callback: function ($$v) {
                        _vm.keyword = typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "keyword",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "分类：" } },
                [
                  _c("el-cascader", {
                    ref: "categoryCascader",
                    attrs: {
                      options: _vm.filteredCategorys,
                      props: _vm.propsPlant2,
                      clearable: "",
                      "popper-class": "popper-select",
                      size: "small",
                      placeholder: "请输入平台商品分类",
                      "show-all-levels": false,
                      "collapse-tags": true,
                    },
                    on: { change: _vm.ceshi },
                    model: {
                      value: _vm.tableFrom.categoryId3s,
                      callback: function ($$v) {
                        _vm.$set(_vm.tableFrom, "categoryId3s", $$v)
                      },
                      expression: "tableFrom.categoryId3s",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.handleSearchList },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            shadow: "never",
            bordered: false,
            "body-style": { padding: "20px" },
          },
        },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "hasPermi",
                  rawName: "v-hasPermi",
                  value: ["merchant:supplierProduct:rule:add"],
                  expression: "['merchant:supplierProduct:rule:add']",
                },
              ],
              attrs: { size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.onEdit()
                },
              },
            },
            [_vm._v("批量处理")]
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              ref: "table",
              staticClass: "mt20",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.data,
                size: "small",
                "highlight-current-row": "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { prop: "proId", label: "ID", "min-width": "60" },
              }),
              _c("el-table-column", {
                attrs: { prop: "name", label: "名称", "min-width": "150" },
              }),
              _c("el-table-column", {
                attrs: { label: "商品图", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "demo-image__preview line-heightOne" },
                          [
                            _c("el-image", {
                              attrs: { src: scope.row.mainImg },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "140", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["merchant:supplierProduct:rule:add"],
                                expression:
                                  "['merchant:supplierProduct:rule:add']",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.onEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("添加到我的商品")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": _vm.$constants.page.limit,
                  "page-size": _vm.tableFrom.pageSize,
                  "current-page": _vm.tableFrom.pageNum,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加到我的商品",
            visible: _vm.dialogVisible,
            width: "600px",
            "close-on-click-modal": false,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { margin: "0 auto" } },
            [
              _c(
                "el-form",
                {
                  ref: "addForm",
                  attrs: {
                    model: _vm.formValidate,
                    rules: _vm.addFormRules,
                    "label-width": "120px",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "平台分类：", prop: "categoryId" } },
                    [
                      _c("el-cascader", {
                        staticClass: "form_content_width",
                        attrs: {
                          options: _vm.merPlatProductClassify,
                          props: _vm.propsPlant,
                          clearable: "",
                          size: "small",
                          placeholder: "请输入平台商品分类",
                        },
                        on: { change: _vm.onChangeCategory },
                        model: {
                          value: _vm.formValidate.categoryId,
                          callback: function ($$v) {
                            _vm.$set(_vm.formValidate, "categoryId", $$v)
                          },
                          expression: "formValidate.categoryId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "品牌：", prop: "brandName" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "input-width-80 mr20",
                          attrs: {
                            placeholder: "请选择品牌",
                            clearable: "",
                            filterable: "",
                            loading: _vm.brandLoading,
                            disabled: !_vm.formValidate.categoryId,
                          },
                          model: {
                            value: _vm.formValidate.brandName,
                            callback: function ($$v) {
                              _vm.$set(_vm.formValidate, "brandName", $$v)
                            },
                            expression: "formValidate.brandName",
                          },
                        },
                        _vm._l(_vm.brandList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.name },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品让利比例：", prop: "ratio" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "input-width-80",
                          attrs: { placeholder: "请输入商品让利比例" },
                          model: {
                            value: _vm.formValidate.ratio,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formValidate,
                                "ratio",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "formValidate.ratio",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("%")])],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "加价比例：", prop: "ratioM" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "input-width-80",
                          attrs: { placeholder: "请输入加价比例" },
                          model: {
                            value: _vm.formValidate.ratioM,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formValidate,
                                "ratioM",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "formValidate.ratioM",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("%")])],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm.dialogType == 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "商品关键字：", prop: "keyword" } },
                        [
                          _c("keyword", {
                            staticClass: "input-width-80",
                            attrs: { labelarr: _vm.labelarr },
                            on: { getLabelarr: _vm.getLabelarr },
                          }),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v("用户可以根据关键字进行商品搜索"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: "单位：", prop: "unitName" } },
                    [
                      _c("el-input", {
                        staticClass: "input-width-80",
                        attrs: { placeholder: "请输入单位" },
                        model: {
                          value: _vm.formValidate.unitName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formValidate,
                              "unitName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "formValidate.unitName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.dialogType == 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "商品简介：", prop: "intro" } },
                        [
                          _c("el-input", {
                            staticClass: "input-width-80",
                            attrs: {
                              type: "textarea",
                              maxlength: "100",
                              rows: 3,
                              placeholder: "请输入商品简介",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.formValidate.intro,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "intro",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.intro",
                            },
                          }),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v("通过公众号分享商品详情，会展示此简介信息"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }